import { render, staticRenderFns } from "./AssetMeta.vue?vue&type=template&id=ff0682e4&scoped=true"
import script from "./AssetMeta.vue?vue&type=script&lang=ts"
export * from "./AssetMeta.vue?vue&type=script&lang=ts"
import style0 from "./AssetMeta.vue?vue&type=style&index=0&id=ff0682e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0682e4",
  null
  
)

export default component.exports